<h3>
  <span [style.background-color]="bgColor">
    {{ title }}
  </span>
</h3>